<script>
import MixedGridFiltersItemRange from '@phoenix/mixins/components/mixedGrid/MixedGridFiltersItemRange';

export default {
  mixins: [MixedGridFiltersItemRange],

  computed: {
    rangeClasses() {
      return ['range noUi-target noUi-ltr noUi-horizontal noUi-txt-dir-ltr', { 'btn--disabled': this.filter.disabled }];
    },
  },
};
</script>

<template>
  <div class="range-slider range-slider--centered" data-cy="mixed-grid-filter-range">
    <div
      :id="uniqueId"
      ref="range"
      :class="rangeClasses"
      :data-property="filter.id"
      :data-label="filter.label"
      :data-options="filter.options"
      :data-items="filter.items"
    ></div>
  </div>
</template>
